function capFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

export const countries = [
  'Andorra',
  'United Arab Emirates',
  'Afghanistan',
  'Antigua and Barbuda',
  'Anguilla',
  'Albania',
  'Armenia',
  'Angola',
  'Antarctica',
  'Argentina',
  'American Samoa',
  'Austria',
  'Australia',
  'Aruba',
  'Alland Islands',
  'Azerbaijan',
  'Bosnia and Herzegovina',
  'Barbados',
  'Bangladesh',
  'Belgium',
  'Burkina Faso',
  'Bulgaria',
  'Bahrain',
  'Burundi',
  'Benin',
  'Saint Barthelemy',
  'Bermuda',
  'Brunei Darussalam',
  'Bolivia',
  'Brazil',
  'Bahamas',
  'Bhutan',
  'Bouvet Island',
  'Botswana',
  'Belarus',
  'Belize',
  'Canada',
  'Cocos (Keeling) Islands',
  'Congo, Democratic Republic of the',
  'Central African Republic',
  'Congo, Republic of the',
  'Switzerland',
  "Cote d'Ivoire",
  'Cook Islands',
  'Chile',
  'Cameroon',
  'China',
  'Colombia',
  'Costa Rica',
  'Cuba',
  'Cape Verde',
  'Curacao',
  'Christmas Island',
  'Cyprus',
  'Czech Republic',
  'Germany',
  'Djibouti',
  'Denmark',
  'Dominica',
  'Dominican Republic',
  'Algeria',
  'Ecuador',
  'Estonia',
  'Egypt',
  'Western Sahara',
  'Eritrea',
  'Spain',
  'Ethiopia',
  'Finland',
  'Fiji',
  'Falkland Islands (Malvinas)',
  'Micronesia, Federated States of',
  'Faroe Islands',
  'France',
  'Gabon',
  'United Kingdom',
  'Grenada',
  'Georgia',
  'French Guiana',
  'Guernsey',
  'Ghana',
  'Gibraltar',
  'Greenland',
  'Gambia',
  'Guinea',
  'Guadeloupe',
  'Equatorial Guinea',
  'Greece',
  'South Georgia and the South Sandwich Islands',
  'Guatemala',
  'Guam',
  'Guinea-Bissau',
  'Guyana',
  'Hong Kong',
  'Heard Island and McDonald Islands',
  'Honduras',
  'Croatia',
  'Haiti',
  'Hungary',
  'Indonesia',
  'Ireland',
  'Israel',
  'Isle of Man',
  'India',
  'British Indian Ocean Territory',
  'Iraq',
  'Iran, Islamic Republic of',
  'Iceland',
  'Italy',
  'Jersey',
  'Jamaica',
  'Jordan',
  'Japan',
  'Kenya',
  'Kyrgyzstan',
  'Cambodia',
  'Kiribati',
  'Comoros',
  'Saint Kitts and Nevis',
  "Korea, Democratic People's Republic of",
  'Korea, Republic of',
  'Kuwait',
  'Cayman Islands',
  'Kazakhstan',
  "Lao People's Democratic Republic",
  'Lebanon',
  'Saint Lucia',
  'Liechtenstein',
  'Sri Lanka',
  'Liberia',
  'Lesotho',
  'Lithuania',
  'Luxembourg',
  'Latvia',
  'Libya',
  'Morocco',
  'Monaco',
  'Moldova, Republic of',
  'Montenegro',
  'Saint Martin (French part)',
  'Madagascar',
  'Marshall Islands',
  'Macedonia, the Former Yugoslav Republic of',
  'Mali',
  'Myanmar',
  'Mongolia',
  'Macao',
  'Northern Mariana Islands',
  'Martinique',
  'Mauritania',
  'Montserrat',
  'Malta',
  'Mauritius',
  'Maldives',
  'Malawi',
  'Mexico',
  'Malaysia',
  'Mozambique',
  'Namibia',
  'New Caledonia',
  'Niger',
  'Norfolk Island',
  'Nigeria',
  'Nicaragua',
  'Netherlands',
  'Norway',
  'Nepal',
  'Nauru',
  'Niue',
  'New Zealand',
  'Oman',
  'Panama',
  'Peru',
  'French Polynesia',
  'Papua New Guinea',
  'Philippines',
  'Pakistan',
  'Poland',
  'Saint Pierre and Miquelon',
  'Pitcairn',
  'Puerto Rico',
  'Palestine, State of',
  'Portugal',
  'Palau',
  'Paraguay',
  'Qatar',
  'Reunion',
  'Romania',
  'Serbia',
  'Russian Federation',
  'Rwanda',
  'Saudi Arabia',
  'Solomon Islands',
  'Seychelles',
  'Sudan',
  'Sweden',
  'Singapore',
  'Saint Helena',
  'Slovenia',
  'Svalbard and Jan Mayen',
  'Slovakia',
  'Sierra Leone',
  'San Marino',
  'Senegal',
  'Somalia',
  'Suriname',
  'South Sudan',
  'Sao Tome and Principe',
  'El Salvador',
  'Sint Maarten (Dutch part)',
  'Syrian Arab Republic',
  'Swaziland',
  'Turks and Caicos Islands',
  'Chad',
  'French Southern Territories',
  'Togo',
  'Thailand',
  'Tajikistan',
  'Tokelau',
  'Timor-Leste',
  'Turkmenistan',
  'Tunisia',
  'Tonga',
  'Turkey',
  'Trinidad and Tobago',
  'Tuvalu',
  'Taiwan, Province of China',
  'United Republic of Tanzania',
  'Ukraine',
  'Uganda',
  'United States',
  'Uruguay',
  'Uzbekistan',
  'Holy See (Vatican City State)',
  'Saint Vincent and the Grenadines',
  'Venezuela',
  'British Virgin Islands',
  'US Virgin Islands',
  'Vietnam',
  'Vanuatu',
  'Wallis and Futuna',
  'Samoa',
  'Kosovo',
  'Yemen',
  'Mayotte',
  'South Africa',
  'Zambia',
  'Zimbabwe',
];

export const generateName = () => {
  const name1 = [
    'Balanced',
    'Baronial',
    'Beaming',
    'Beatific',
    'Beauteous',
    'Beautified',
    'Beautiful',
    'Becoming',
    'Beefy',
    'Believable',
    'Beloved',
    'Benedictory',
    'Benefic',
    'Beneficent',
    'Beneficial',
    'Beneficiary',
    'Benevolent',
    'Benign',
    'Benignant',
    'Bent on',
    'Best',
    'Better',
    'Big',
    'Big-hearted',
    'Big-time',
    'Biggest',
    'Bijou',
    'Blameless',
    'Blazing',
    'Blessed',
    'Blissful',
    'Blithe',
    'Blooming',
    'Blue-ribbon',
    'Bodacious',
    'Boisterous',
    'Bold',
    'Bona fide',
    'Bonny',
    'Bonzer',
    'Boss',
    'Bound',
    'Bounteous',
    'Bountiful',
    'Brainy',
    'Brave',
    'Brawny',
    'Breezy',
    'Brief',
    'Bright',
    'Brill',
    'Brilliant',
    'Brimming',
    'Brisk',
    'Broadminded',
    'Brotherly',
    'Bubbly',
    'Budding',
    'Buff',
    'Bullish',
    'Buoyant',
    'Businesslike',
    'Bustling',
    'Busy',
    'Buxom Calm',
    'Calmative',
    'Calming',
    'Can-do',
    'Candescent',
    'Canny',
    'Canty',
    'Capable',
    'Capital',
    'Captivating',
    'Cared for',
    'Carefree',
    'Careful',
    'Caring',
    'Casual',
    'Causative',
    'Celebrated',
    'Celeritous',
    'Celestial',
    'Centered',
    'Central',
    'Cerebral',
    'Certain',
    'Champion',
    'Changeable',
    'Changeless',
    'Charismatic',
    'Charitable',
    'Charming',
    'Cheerful',
    'Cherished',
    'Cherry',
    'Chic',
    'Childlike',
    'Chipper',
    'Chirpy',
    'Chivalrous',
    'Choice',
    'Chosen',
    'Chummy',
    'Civic',
    'Civil',
    'Civilized',
    'Clairvoyant',
    'Classic',
    'Classical',
    'Classy',
    'Clean',
    'Clear',
    'Clear-cut',
    'Clearheaded',
    'Clement',
    'Clever',
    'Close',
    'Clubby',
    'Coadjutant',
    'Coequal',
    'Cogent',
    'Cognizant',
    'Coherent',
    'Collected',
    'Colossal',
    'Colourful',
    'Coltish',
    'Come-at-able',
    'Comely',
    'Comfortable',
    'Comforting',
    'Comic',
    'Comical',
    'Commanding',
    'Commendable',
    'Commendatory',
    'Commending',
    'Commiserative',
    'Committed',
    'Commodious',
    'Commonsensical',
    'Communicative',
    'Commutual',
    'Companionable',
    'Compassionate',
    'Compatible',
    'Compelling',
    'Competent',
    'Complete',
    'Completed',
    'Complimentary',
    'Composed',
    'Comprehensive',
    'Concentrated',
    'Concise',
    'Conclusive',
    'Concordant',
    'Concrete',
    'Condolatory',
    'Confederate',
    'Conferrable',
    'Confident',
    'Congenial',
    'Congruous',
    'Connected',
    'Conscientious',
    'Conscious',
    'Consensual',
    'Consentaneous',
    'Consentient',
    'Consequential',
    'Considerable',
    'Considerate',
    'Consistent',
    'Consonant',
    'Conspicuous',
    'Constant',
    'Constitutional',
    'Constructive',
    'Contemplative',
    'Contemporary',
    'Content',
    'Contributive',
    'Convenient',
    'Conversant',
    'Convictive',
    'Convincing',
    'Convivial',
    'Cool',
    'Cooperative',
    'Coordinated',
    'Copacetic',
    'Copious',
    'Cordial',
    'Correct',
    'Coruscant',
    'Cosmic',
    'Cosy',
    'Courageous',
    'Courteous',
    'Courtly',
    'Cozy',
    'Crackerjack',
    'Creamy',
    'Creative',
    'Credible',
    'Creditable',
    'Crisp',
    'Crucial',
    'Crystal (Clear)',
    'Cuddly',
    'Cultivated',
    'Cultured',
    'Cunning',
    'Curious',
    'Current',
    'Curvaceous',
    'Cushy',
    'Cute',
    'Cutting-edge Dainty',
    'Dandy',
    'Dapper',
    'Daring',
    'Darling',
    'Dashing',
    'Dauntless',
    'Dazzling',
    'Dear',
    'Debonair',
    'Decent',
    'Deciding',
    'Decisive',
    'Decorous',
    'Dedicated',
    'Deep',
    'Defiant',
    'Defiantly',
    'Definite',
    'Deft',
    'Delectable',
    'Deliberate',
    'Delicate',
    'Delicious',
    'Delighted',
    'Delightful',
    'Deluxe',
    'Demonstrative',
    'Demulcent',
    'Dependable',
    'Deserving',
    'Designer',
    'Desirable',
    'Desired',
    'Desirous',
    'Destined',
    'Determined',
    'Developed',
    'Developing',
    'Devoted',
    'Devotional',
    'Devout',
    'Dexterous',
    'Didactic',
    'Different',
    'Dignified',
    'Diligent',
    'Dinkum',
    'Diplomatic',
    'Direct',
    'Disarming',
    'Discerning',
    'Disciplined',
    'Discreet',
    'Discrete',
    'Discriminating',
    'Dispassionate',
    'Distinct',
    'Distinctive',
    'Distinguished',
    'Distinguishing',
    'Diverse',
    'Diverting',
    'Divine',
    'Doable',
    'Dominant',
    'Doting',
    'Doubtless',
    'Doughty',
    'Down-to-earth',
    'Dreamy',
    'Driven',
    'Driving',
    'Durable',
    'Dutiful',
    'Dynamic',
    'Dynamite',
    'Fab',
    'Fabulous',
    'Facile',
    'Factual',
    'Facultative',
    'Fain',
    'Fair',
    'Faithful',
    'Famed',
    'Familial',
    'Familiar',
    'Family',
    'Famous',
    'Fancy',
    'Fantastic',
    'Far-reaching',
    'Far-sighted',
    'Fascinating',
    'Fashionable',
    'Fast',
    'Faultless',
    'Favorable',
    'Favored',
    'Favorite',
    'Fearless',
    'Feasible',
    'Fecund',
    'Felicitous',
    'Fertile',
    'Fervent',
    'Festal',
    'Festive',
    'Fetching',
    'Fiery',
    'Fine',
    'Finer',
    'Finest',
    'Firm',
    'First',
    'First-class',
    'First-rate',
    'Fit',
    'Fitting',
    'Flamboyant',
    'Flash',
    'Flashy',
    'Flavorful',
    'Flawless',
    'Fleet',
    'Flexible',
    'Flourishing',
    'Fluent',
    'Flying',
    'Focused',
    'Fond',
    'For real',
    'Forceful',
    'Foremost',
    'Foresighted',
    'Forgiving',
    'Formidable',
    'Forthcoming',
    'Forthright',
    'Fortified',
    'Fortuitous',
    'Fortunate',
    'Forward',
    'Foundational',
    'Four-star',
    'Foxy',
    'Fragrant',
    'Frank',
    'Fraternal',
    'Free',
    'Freely',
    'Fresh',
    'Friendly',
    'Frisky',
    'Frolicsome',
    'Front-page',
    'Fruitful',
    'Fulfilled',
    'Fulfilling',
    'Full',
    'Fun',
    'Funny',
    'FuturisticGainful',
    'Gallant',
    'Galore',
    'Game',
    'Gamesome',
    'Generous',
    'Genial',
    'Genteel',
    'Gentle',
    'Genuine',
    'Germane',
    'Get-at-able',
    'Gettable',
    'Giddy',
    'Gifted',
    'Giving',
    'Glad',
    'Glamorous',
    'Gleaming',
    'Gleeful',
    'Glorious',
    'Glowing',
    'Gnarly',
    'Goal-oriented',
    'Godly',
    'Golden',
    'Good',
    'Good-humored',
    'Good-looking',
    'Good-natured',
    'Goodhearted',
    'Goodly',
    'Gorgeous',
    'Graced',
    'Graceful',
    'Gracile',
    'Gracious',
    'Gradely',
    'Graithly',
    'Grand',
    'Grateful',
    'Gratified',
    'Gratifying',
    'Great',
    'Greatest',
    'Greathearted',
    'Gregarious',
    'Groovy',
    'Grounded',
    'Growing',
    'Grown',
    'Guaranteed',
    'Gubernatorial',
    'Guided',
    'Guiding',
    'Guileless',
    'Guilt-free',
    'Guiltless',
    'Gumptious',
    'Gustatory',
    'Gutsy',
    'GymnasticIdeal',
    'Idealistic',
    'Idiosyncratic',
    'Idolized',
    'Illimitable',
    'Illuminated',
    'Illuminating',
    'Illustrious',
    'Imaginative',
    'Imitable',
    'Immaculate',
    'Immeasurable',
    'Immediate',
    'Immense',
    'Immortal',
    'Immune',
    'Impartial',
    'Impassioned',
    'Impeccable',
    'Impeccant',
    'Imperturbable',
    'Impish',
    'Important',
    'Impressive',
    'Improved',
    'Improving',
    'Improvisational',
    'In',
    'Incisive',
    'Included',
    'Inclusive',
    'Incomparable',
    'Incomplex',
    'Incontestable',
    'Incontrovertible',
    'Incorrupt',
    'Incredible',
    'Inculpable',
    'Indefatigable',
    'Independent',
    'Indestructible',
    'Indispensable',
    'Indisputable',
    'Individual',
    'Individualistic',
    'Indivisible',
    'Indomitable',
    'Indubitable',
    'Industrious',
    'Inerrant',
    'Inexhaustible',
    'Infallible',
    'Infant',
    'Infinite',
    'Influential',
    'Informative',
    'Informed',
    'Ingenious',
    'Inimitable',
    'Initiate',
    'Initiative',
    'Innocent',
    'Innovative',
    'Innoxious',
    'Inquisitive',
    'Insightful',
    'Inspired',
    'Inspiring',
    'Inspiriting',
    'Instantaneous',
    'Instinctive',
    'Instructive',
    'Instrumental',
    'Integral',
    'Integrated',
    'Intellectual',
    'Intelligent',
    'Intense',
    'Intent',
    'Interactive',
    'Interconnected',
    'Interested',
    'Interesting',
    'Internal',
    'Intertwined',
    'Intimate',
    'Intoxicating',
    'Intrepid',
    'Intriguing',
    'Introducer',
    'Inventive',
    'Invigorated',
    'Invigorating',
    'Invincible',
    'Inviolable',
    'Inviting',
    'Irrefragable',
    'Irrefutable',
    'Irreplaceable',
    'Irrepressible',
    'Irreproachable',
    'Irresistible',
  ];

  const name2 = ['store'];

  const name =
    capFirst(name1[getRandomInt(0, name1.length + 1)]) +
    ' ' +
    capFirst(name2[0]);
  return name;
};
